import { Component } from '@angular/core';

@Component({
    selector: 'cdp-not-authorized-page',
    templateUrl: './not-authorized-page.component.html',
    styleUrl: './not-authorized-page.component.scss',
    standalone: false
})
export class NotAuthorizedPageComponent {}
